import React from 'react';
import { Chip, Icon } from '@material-ui/core';
import { KeywordModel } from '../../Models/KeywordModel';

interface IKeywordChip {
    keyword: KeywordModel,
    selected: boolean,
    onSelectKeyword?: (keyword: KeywordModel) => void,
    onDeselectKeyword?: (keyword: KeywordModel) => void
}

export function KeywordChip({ keyword, selected, onSelectKeyword, onDeselectKeyword }: IKeywordChip) {

    return (
        <Chip
            color="primary"
            variant={selected ? 'default' : 'outlined'}
            key={ keyword.description }
            label={ keyword.description }
            onClick={() => {
                if (selected && onDeselectKeyword) {
                    onDeselectKeyword(keyword);
                }
                else if (!selected && onSelectKeyword) {
                    onSelectKeyword(keyword);
                }
            }}
            onDelete={() => {
                if (selected && onDeselectKeyword) {
                    onDeselectKeyword(keyword);
                }
            }}
            deleteIcon={selected ? <Icon>close</Icon> : <></>}
            style={{ margin: '4px' }}
        />
    );
}

export default React.memo(
    KeywordChip,
    (p, n) => (p.selected === n.selected)
);